module.exports = __webpack_public_path__ + "static/media/steps-next.77b906b6.svg";